import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useCart } from '../../context/CartContext';
import ProductImageGallery from '../../components/ProductImageGallery';

const Switch2PortableStorageBag = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [activeTab, setActiveTab] = useState('overview');

  // 产品图片数组
  const productImages = [
    "/images/shop-products/switch-portable-storage-bag/switch 2 All-In-One Carrying Case.jpg",
    "/images/shop-products/switch-portable-storage-bag/O1CN019bCtDF1SnKQM3bUe5_!!2208285642291-0-cib.jpg",
    "/images/shop-products/switch-portable-storage-bag/O1CN01nXwXQD1SnKQMtbR4Q_!!2208285642291-0-cib.jpg",
    "/images/shop-products/switch-portable-storage-bag/O1CN01oWDCYI1SnKQMChUDx_!!2208285642291-0-cib.jpg",
    "/images/shop-products/switch-portable-storage-bag/O1CN01t4tzVk1SnKQNVJWpD_!!2208285642291-0-cib.jpg",
    "/images/shop-products/switch-portable-storage-bag/O1CN01W1q4Pi1SnKQK3FcPj_!!2208285642291-0-cib.jpg"
  ];

  // 产品信息
  const product = {
    id: 9,
    name: "Nintendo Switch 2 EVA Carrying Case – Handheld Storage Bag",
    category: "nintendo-switch",
    price: "S$49.90",
    originalPrice: "S$59.90",
    description: "EVA carrying case with double zipper closure for Switch 2 and accessories",
    specs: {
      "Material": "EVA",
      "Size": "29 × 16 × 17 cm",
      "Closure": "Double zipper",
      "Interior": "Padded lining",
      "Weight": "0.8 kg",
      "Compatibility": "Switch 2 & Accessories",
      "Protection": "Waterproof",
      "Design": "All-in-One"
    },
    features: [
      "EVA Material",
      "Double Zipper Closure",
      "Padded Lining",
      "Waterproof Protection",
      "All-in-One Design",
      "Lightweight (0.8kg)",
      "Compact Size (29×16×17cm)",
      "Travel Friendly"
    ],
    inStock: true,
    rating: 4.6,
    reviews: 234
  };

  const handleAddToCart = async () => {
    setIsAddingToCart(true);
    await new Promise(resolve => setTimeout(resolve, 500));
    
    addToCart({
      ...product,
      quantity,
      image: productImages[0]
    });
    
    setIsAddingToCart(false);
  };

  const handleBuyNow = async () => {
    await handleAddToCart();
    navigate('/cart');
  };

  return (
    <div className="min-h-screen bg-dark-400">
      {/* 面包屑导航 */}
      <div className="bg-dark-300 border-b border-gray-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center space-x-2 text-sm text-gray-300">
            <button 
              onClick={() => navigate('/')}
              className="hover:text-white transition-colors"
            >
              Home
            </button>
            <span>/</span>
            <button 
              onClick={() => navigate('/shop')}
              className="hover:text-white transition-colors"
            >
              Shop
            </button>
            <span>/</span>
            <button 
              onClick={() => navigate('/category/nintendo-switch')}
              className="hover:text-white transition-colors"
            >
              Nintendo Switch
            </button>
            <span>/</span>
            <span className="text-white font-medium">{product.name}</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* 产品图片 */}
          <div className="space-y-4">
            <ProductImageGallery 
              images={productImages} 
              currentImage={productImages[currentImage]}
              onImageChange={(image) => {
                const index = productImages.findIndex(img => img === image);
                setCurrentImage(index);
              }}
            />
          </div>

          {/* 产品信息 */}
          <div className="space-y-6">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                {product.name}
              </h1>
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className={`w-5 h-5 ${
                        i < Math.floor(product.rating)
                          ? 'text-yellow-400'
                          : 'text-gray-500'
                      }`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                  <span className="ml-2 text-sm text-gray-300">
                    {product.rating} ({product.reviews} reviews)
                  </span>
                </div>
                <span className="text-sm text-green-400 font-medium">
                  {product.inStock ? 'In Stock' : 'Out of Stock'}
                </span>
              </div>
            </div>

            {/* 价格 */}
            <div className="flex items-center space-x-4">
              <span className="text-3xl font-bold text-white">
                {product.price}
              </span>
              <span className="text-xl text-gray-400 line-through">
                {product.originalPrice}
              </span>
              <span className="bg-red-600 text-white text-sm font-medium px-3 py-1 rounded-lg">
                Save S$10.00
              </span>
            </div>

            {/* 产品描述 */}
            <p className="text-gray-300 text-lg leading-relaxed">
              {product.description}
            </p>

            {/* 数量选择 */}
            <div className="space-y-3">
              <h3 className="text-lg font-medium text-white">Quantity</h3>
              <div className="flex items-center space-x-4">
                <div className="flex items-center border border-gray-600 rounded-lg bg-dark-300">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="px-4 py-2 text-gray-300 hover:text-white transition-colors"
                  >
                    -
                  </button>
                  <span className="px-6 py-2 border-x border-gray-600 min-w-[80px] text-center text-white font-medium">
                    {quantity}
                  </span>
                  <button
                    onClick={() => setQuantity(quantity + 1)}
                    className="px-4 py-2 text-gray-300 hover:text-white transition-colors"
                  >
                    +
                  </button>
                </div>
                <span className="text-sm text-gray-400">
                  Max 10 items
                </span>
              </div>
            </div>

            {/* 操作按钮 */}
            <div className="space-y-3">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleAddToCart}
                disabled={isAddingToCart || !product.inStock}
                className={`w-full py-4 px-6 rounded-lg font-medium transition-colors ${
                  isAddingToCart || !product.inStock
                    ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                    : 'bg-green-600 text-white hover:bg-green-700'
                }`}
              >
                {isAddingToCart ? 'Adding...' : `Add to Cart - ${product.price}`}
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleBuyNow}
                disabled={!product.inStock}
                className={`w-full py-4 px-6 rounded-lg font-medium transition-colors ${
                  !product.inStock
                    ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                    : 'bg-gray-700 text-white hover:bg-gray-600'
                }`}
              >
                Buy Now
              </motion.button>
            </div>

            {/* 配送信息 */}
            <div className="space-y-4 text-base">
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <div>
                  <div className="text-white font-semibold text-lg">Free Meet Up (Available at Sengkang & Orchard locations)</div>
                  <div className="text-gray-400 text-base">Available Shipping</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <div>
                  <div className="text-white font-semibold text-lg">Meet Up Free</div>
                  <div className="text-gray-400 text-base">Available at Sengkang & Orchard locations</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 标签导航 */}
        <div className="mt-16 border-b border-gray-600">
          <nav className="flex space-x-8">
            <button
              onClick={() => setActiveTab('overview')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'overview'
                  ? 'border-green-500 text-green-500'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              Overview
            </button>
            <button
              onClick={() => setActiveTab('specifications')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'specifications'
                  ? 'border-green-500 text-green-500'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              Specifications
            </button>
            <button
              onClick={() => setActiveTab('reviews')}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'reviews'
                  ? 'border-green-500 text-green-500'
                  : 'border-transparent text-gray-400 hover:text-gray-300'
              }`}
            >
              Reviews ({product.reviews})
            </button>
          </nav>
        </div>

        {/* 标签内容 */}
        <div className="mt-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* 产品概览 */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Product Overview</h2>
                <div className="space-y-4 text-gray-300">
                  <p>
                    The Switch 2 Portable Storage Bag is an all-in-one carrying solution designed specifically for Nintendo Switch 2 
                    and all its accessories. This waterproof storage bag provides comprehensive protection and organization for your 
                    gaming setup, ensuring everything stays safe and organized during travel.
                  </p>
                  <p>
                    Made from high-quality waterproof nylon material, this storage bag offers excellent durability and protection against 
                    water, dust, and everyday wear. The padded interior provides cushioning for your Switch 2 console, while multiple 
                    pockets keep your Joy-Con controllers, cables, and other accessories neatly organized.
                  </p>
                  <p>
                    Perfect for travel, commuting, or daily storage, this compact yet spacious bag features a secure zipper closure and 
                    lightweight design. The all-in-one design means you can carry your entire Switch 2 setup in one convenient package, 
                    making it ideal for gaming on the go.
                  </p>
                </div>
              </div>

              {/* 关键特性 */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-6">Key Features</h2>
                <div className="space-y-4">
                  {[
                    {
                      title: "All-in-One Design",
                      description: "Complete carrying solution for Switch 2 and all accessories"
                    },
                    {
                      title: "Waterproof Protection",
                      description: "High-quality nylon material protects against water and dust"
                    },
                    {
                      title: "Padded Interior",
                      description: "Soft padding provides cushioning for your console"
                    },
                    {
                      title: "Multiple Pockets",
                      description: "Organized storage for controllers, cables, and accessories"
                    }
                  ].map((feature, index) => (
                    <div key={index} className="flex items-start space-x-3">
                      <svg className="w-6 h-6 text-green-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <h3 className="font-semibold text-white">{feature.title}</h3>
                        <p className="text-gray-300 text-sm">{feature.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'specifications' && (
            <div className="bg-dark-300 rounded-lg shadow-sm border border-gray-600">
              <div className="px-6 py-4 border-b border-gray-600">
                <h3 className="text-lg font-medium text-white">Technical Specifications</h3>
              </div>
              <div className="px-6 py-4">
                <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {Object.entries(product.specs).map(([key, value]) => (
                    <div key={key} className="flex justify-between py-2 border-b border-gray-600 last:border-b-0">
                      <dt className="font-medium text-white">{key}</dt>
                      <dd className="text-gray-300">{value}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-white">User Reviews</h2>
              <div className="bg-dark-300 rounded-lg p-6">
                <p className="text-gray-300 text-center">No reviews yet, be the first to review!</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Switch2PortableStorageBag;